export const environment = {
  production: import.meta.env.MODE === 'production',
  development: import.meta.env.MODE === 'development',

  app: {
    name: import.meta.env.VITE_APP_NAME || 'Solvpath Support',
    version: import.meta.env.VITE_APP_VERSION || '1.0.0',
  },

  api: {
    baseUrl: import.meta.env.VITE_API_URL || 'https://api.staging.solvpath.com/',
    timeout: parseInt(import.meta.env.VITE_API_TIMEOUT || '10000'),
    websocketEndpoint: import.meta.env.VITE_WEBSOCKET_ENDPOINT,
  },

  features: {
    enableDevTools: import.meta.env.VITE_ENABLE_DEV_TOOLS === 'true',
    enableQueryPersist: import.meta.env.VITE_ENABLE_QUERY_PERSIST === 'true',
  },

  monitoring: {
    sentryDsn: import.meta.env.VITE_SENTRY_DSN,
    sentryEnv: import.meta.env.VITE_SENTRY_ENV || import.meta.env.MODE,
  },

  thirdParty: {
    captchaSiteKey: import.meta.env.VITE_CAPTCHA_SITE_KEY,
    chatBotUrl: import.meta.env.VITE_CHAT_BOT_URL,
    googleMapsKey: import.meta.env.VITE_GOOGLE_MAPS_KEY,
    gatewayBaseUrl: import.meta.env.VITE_GATEWAY_BASE_URL,
    // Mouseflow Website ID. Set in production only; blank elsewhere → loader no-ops.
    mouseflowProjectId: import.meta.env.VITE_MOUSEFLOW_PROJECT_ID || '',
  },

  analytics: {
    gaTrackingId: import.meta.env.VITE_GA_TRACKING_ID,
  },
}
